<template>
    <div class="body_main">
        <div class="body_bd">
            <div class="today_panel" v-loading="statLoading">
                <button type="button" class="today_panel_left" :class="{ today_panel_left_active: !queryParams.reStatus && !queryParams.isFree && !queryParams.reStatusMiniDoc }" @click="filterByStatus('')">
                    <span class="today_panel_icon"><el-icon size="28"><Calendar /></el-icon></span>
                    <span class="today_panel_title">
                        <span class="today_main_title">预约汇总</span>
                        <span class="today_sub_title">{{ queryParams.schDate }}</span>
                    </span>
                    <span class="today_divider"></span>
                    <span class="today_total_block">
                        <span class="today_total_num">{{ statData.total ?? 0 }}</span>
                        <span class="today_total_label">总预约数</span>
                    </span>
                </button>
                <div class="today_panel_right">
                    <button v-for="card in statCards" :key="card.key" type="button"
                            class="stat_card" :class="[card.className, { stat_card_active: !queryParams.reStatusMiniDoc && queryParams.reStatus === card.status && queryParams.isFree === (card.isFree || '') }]"
                            @click="filterByStatus(card.status, card.isFree)">
                        <span class="stat_card_icon"><el-icon size="20"><component :is="card.icon" /></el-icon></span>
                        <span class="stat_card_info">
                            <span class="stat_num">{{ statData[card.key] ?? 0 }}</span>
                            <span class="stat_label">{{ card.label }}</span>
                        </span>
                    </button>
                </div>
            </div>
            <!-- 搜索-->
            <el-form class="search_con" :model="queryParams" ref="queryForm" :inline="true" label-width="68px" @submit.prevent="searchReservations">
                <el-form-item label="预约日期">
                    <el-date-picker v-model="queryParams.schDate" type="date"
                                    format="YYYY-MM-DD" value-format="YYYY-MM-DD"
                                    placeholder="请选择预约日期" :clearable="false" style="width: 200px"
                                    @change="searchReservations" />
                </el-form-item>
                <el-form-item label="姓名" prop="articleTitle">
                    <el-input
                        v-model="queryParams.cardPatientName"
                        placeholder="请输入预约人姓名"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="身份证" prop="articleTitle">
                    <el-input
                        v-model="queryParams.cardIdentity"
                        placeholder="请输入预约人身份证"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="手机号" prop="articleTitle">
                    <el-input
                        v-model="queryParams.cardPatientPhone"
                        placeholder="请输入预约人手机号码"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="预约医生">
                    <el-input
                        v-model="queryParams.doctorName"
                        placeholder="请输入预约医生姓名"
                        clearable
                    />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select placeholder="请选择预约单状态" v-model="queryParams.reStatusMiniDoc"
                               style="width: 200px" @change="chooseStatus()">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="待就诊" value="1"></el-option>
                        <el-option label="历史预约单" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="Search" native-type="submit">搜索</el-button>
                    <el-button icon="Refresh" @click="resetQuery">重置</el-button>
                </el-form-item>
            </el-form>

            <!-- 表格-->
            <div class="table_bd">
                <el-table
                    ref="multipleTable"
                    v-loading="tableLoading"
                    :data="tableData"
                    :max-height="tableHeight"
                    style="width: 100%">
                    <template #empty>
                        <el-empty :image-size="120"></el-empty>
                    </template>
                    <el-table-column type="index" label="序号" width="50"> </el-table-column>
                    <el-table-column
                        prop="reSerialNo"
                        label="预约单号">
                    </el-table-column>
                    <el-table-column
                        label="预约人">
                        <template #default="scope">
                            <div class="base_con">
                                <el-image class="elImage" :src="scope.row.avatar"></el-image>
                                <div class="base_info">
                                    <span style="font-size: 16px; font-weight: 600; line-height: 24px">{{ scope.row.cardPatientName }} </span>
                                    <span style="font-size: 14px; color:#aaa; line-height: 24px">{{ scope.row.sexText }}  {{ scope.row.age }}岁</span>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人手机号">
                        <template #default="scope">
                            <span>{{ scope.row.cardPatientPhone === null ? '---' : scope.row.cardPatientPhone }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约人身份证">
                        <template #default="scope">
                            <span>{{ scope.row.cardIdentity === null ? '---' : scope.row.cardIdentity }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约预计时间"
                        width="180">
                        <template #default="scope">
                            <span style="font-size: 14px; font-weight: 600">{{ scope.row.reTime ? scope.row.reTime.slice(0, 16) : '---' }} {{scope.row.reTimeTypeText}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约号"
                        width="90">
                        <template #default="scope">
                            <!-- 排队号由签到/现场挂号/收款成功时分配（当天顺序），未进队列显示 --- -->
                            <span style="font-size: 14px; font-weight: 600">{{ scope.row.queueSeq ? scope.row.queueSeq + '号' : '---' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单类型"
                        width="120">
                        <template #default="scope">
                            <el-tag :type="scope.row.visitType === null || scope.row.visitType === '初诊'?'success':'warning'" disable-transitions>
                                {{ scope.row.visitType === null ? '初诊': scope.row.visitType }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约单状态"
                        width="120">
                        <template #default="scope">
                            <el-tag
                                :type="scope.row.reStatus === '5' ? 'success' : scope.row.reStatus === '6' ? '' :
                                scope.row.reStatus === '7' ? 'danger' : scope.row.reStatus === '8' ? 'warning' :
                                scope.row.reStatus === '4' ? 'info' : scope.row.reStatus === '3' ? 'danger' :
                                scope.row.reStatus === '1' ? 'danger' : ''"
                                disable-transitions>{{ scope.row.reStatusText }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="预约医生">
                        <template #default="scope">
                            <span>{{ scope.row.doctorName === null ? '---' : scope.row.doctorName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="门诊科室">
                        <template #default="scope">
                            <span>{{ scope.row.odName === null ? '---' : scope.row.odName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="创建时间">
                    </el-table-column>
                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="120">
                        <template #default="scope">
                            <el-button type="warning" size="small" @click="handleSign(scope.row)" v-if="scope.row.reStatus === '8'">签到</el-button>
                            <span v-else>—</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 分页-->
            <div class="table_pagination">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="pageNums"
                    layout="prev, pager, next, total, sizes"
                    :total="totalCount">
                </el-pagination>
            </div>

        </div>
    </div>

</template>

<script>
import reservation from "@/assets/scripts/reservation/index";

export default reservation;
</script>

<style scoped>
.today_panel {
    display: flex;
    align-items: stretch;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(64, 128, 255, 0.10);
    margin-bottom: 16px;
    overflow: hidden;
    border: 1px solid #e8efff;
    min-height: 96px;
}

.today_panel_left {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 20px 28px;
    background: linear-gradient(135deg, #4080ff 0%, #73a7ff 100%);
    min-width: 320px;
    flex-shrink: 0;
    cursor: pointer;
    transition: box-shadow 0.2s, filter 0.2s;
    border: 0;
    font: inherit;
}

.today_panel_left:hover { filter: brightness(1.04); }
.today_panel_left_active { box-shadow: inset 0 0 0 2px rgba(255, 255, 255, 0.42); }

.today_panel_icon {
    width: 52px;
    height: 52px;
    background: rgba(255, 255, 255, 0.22);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    flex-shrink: 0;
}

.today_panel_title {
    display: flex;
    flex-direction: column;
    gap: 4px;
    text-align: left;
}

.today_main_title {
    font-size: 20px;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
    letter-spacing: 1px;
}

.today_sub_title { font-size: 13px; color: rgba(255, 255, 255, 0.82); }

.today_divider {
    width: 1px;
    height: 40px;
    background: rgba(255, 255, 255, 0.30);
    flex-shrink: 0;
    margin: 0 4px;
}

.today_total_block {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.today_total_num {
    font-size: 32px;
    font-weight: 800;
    color: #fff;
    line-height: 1;
}

.today_total_label {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.80);
    letter-spacing: 1px;
}

.today_panel_right {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    background: #f7faff;
}

.stat_card {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 10px;
    background: #fff;
    border: 1.5px solid transparent;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    transition: box-shadow 0.2s, transform 0.2s;
    cursor: pointer;
    min-width: 0;
    font: inherit;
    text-align: left;
}

.stat_card:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.10);
    transform: translateY(-2px);
}

.stat_card_active {
    position: relative;
    border-color: var(--card-color);
    background: var(--card-color);
    box-shadow: 0 5px 16px rgba(31, 45, 61, 0.18);
    transform: translateY(-1px);
}

.stat_card_active::after {
    position: absolute;
    top: 8px;
    right: 9px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.92);
    content: '';
}

.stat_card_active .stat_card_icon { background: rgba(255, 255, 255, 0.22); color: #fff; }
.stat_card_active .stat_num,
.stat_card_active .stat_label { color: #fff !important; }

.stat_card_icon {
    width: 38px;
    height: 38px;
    border-radius: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.stat_card_info { display: flex; flex-direction: column; gap: 2px; min-width: 0; }
.stat_num { font-size: 22px; font-weight: 700; line-height: 1; }
.stat_label { font-size: 11px; color: #999; white-space: nowrap; letter-spacing: 0.5px; }

.stat_card_wait_sign { --card-color: #f07800; border-color: #fff3e6; }
.stat_card_wait_sign .stat_card_icon { background: #fff3e6; color: #f07800; }
.stat_card_wait_sign .stat_num { color: #f07800; }
.stat_card_wait_visit { --card-color: #1677ff; border-color: #e6f4ff; }
.stat_card_wait_visit .stat_card_icon { background: #e6f4ff; color: #1677ff; }
.stat_card_wait_visit .stat_num { color: #1677ff; }
.stat_card_visiting { --card-color: #00b96b; border-color: #e6fff0; }
.stat_card_visiting .stat_card_icon { background: #e6fff0; color: #00b96b; }
.stat_card_visiting .stat_num { color: #00b96b; }
.stat_card_done { --card-color: #4080ff; border-color: #f0f5ff; }
.stat_card_done .stat_card_icon { background: #f0f5ff; color: #4080ff; }
.stat_card_done .stat_num { color: #4080ff; }
.stat_card_cancel { --card-color: #cf1322; border-color: #fff1f0; }
.stat_card_cancel .stat_card_icon { background: #fff1f0; color: #cf1322; }
.stat_card_cancel .stat_num { color: #cf1322; }

.today_panel_left:focus-visible,
.stat_card:focus-visible { outline: 2px solid #4080ff; outline-offset: -4px; }

@media (max-width: 1280px) {
    .today_panel_left { min-width: 280px; padding: 18px 20px; gap: 12px; }
    .today_panel_right { gap: 8px; padding: 12px 16px; }
    .stat_card { padding: 12px 10px; gap: 8px; }
}

@media (max-width: 980px) {
    .today_panel { flex-direction: column; }
    .today_panel_left { min-width: 0; }
    .today_panel_right { flex-wrap: wrap; }
    .stat_card { min-width: 140px; }
}
</style>
